import { EARTHQUAKES_RADIUS_METERS_PER_MAGNITUDE } from '../config/earthquakes.config';

/**
 * Formats earthquake location strings by uppercasing the direction text
 * between "km" and "of".
 *
 * Example:
 * "10 km southeast of Chicago" → "10 km SOUTHEAST of Chicago"
 *
 * Matches:
 * - the word "km"
 * - any text between "km" and "of" as the direction
 * - the word "of"
 *
 * Matching is case-insensitive, and only the direction portion is changed.
 */
export const formatEarthquakeLocation = (location = '') =>
  String(location).replace(
    /(\bkm\b)\s+(.+?)\s+(\bof\b)/i,
    (_, km, direction, of) => `${km} ${direction.toUpperCase()} ${of}`,
  );

export const getEarthquakeRadiusMeters = (magnitude) =>
  Math.max(Number(magnitude) || 0, 0) * EARTHQUAKES_RADIUS_METERS_PER_MAGNITUDE;

export const formatEarthquakeCoordinates = (earthquake) => {
  const latitude = Number(earthquake?.latitude);
  const longitude = Number(earthquake?.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return 'N/A';
  }

  return `${latitude.toFixed(3)}, ${longitude.toFixed(3)}`;
};
